import React from 'react';
import { Loader } from 'lucide-react';

/**
 * Loading Spinner Component
 */
export function LoadingSpinner({ size = 24, color = '#3b82f6' }) {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Loader
                size={size}
                color={color}
                style={{ animation: 'spin 1s linear infinite' }}
            />
            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}

/**
 * Loading Skeleton Component
 */
export function Skeleton({ width = '100%', height = '20px', borderRadius = '4px' }) {
    return (
        <div style={{
            width,
            height,
            borderRadius,
            background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
            backgroundSize: '200% 100%',
            animation: 'loading 1.5s ease-in-out infinite'
        }}>
            <style>{`
                @keyframes loading {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
            `}</style>
        </div>
    );
}

/**
 * Card Skeleton Component
 */
export function CardSkeleton() {
    return (
        <div style={{
            padding: '16px',
            backgroundColor: 'white',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
            <Skeleton width="80%" height="20px" style={{ marginBottom: '12px' }} />
            <Skeleton width="100%" height="16px" style={{ marginBottom: '8px' }} />
            <Skeleton width="60%" height="16px" />
        </div>
    );
}

/**
 * Full Page Loading Component
 */
export function PageLoading({ message = 'Carregando...' }) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundColor: '#f8f9fa'
        }}>
            <LoadingSpinner size={48} />
            <p style={{
                marginTop: '16px',
                color: '#64748b',
                fontSize: '16px'
            }}>
                {message}
            </p>
        </div>
    );
}

/**
 * Loading Overlay Component
 */
export function LoadingOverlay({ message = 'Carregando...' }) {
    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 50,
            backdropFilter: 'blur(2px)',
            borderRadius: 'inherit'
        }}>
            <LoadingSpinner size={32} />
            <p style={{
                marginTop: '12px',
                color: '#64748b',
                fontSize: '14px',
                fontWeight: '500'
            }}>
                {message}
            </p>
        </div>
    );
}

/**
 * Empty State Component
 */
export function EmptyState({
    icon,
    title = 'Nenhum item encontrado',
    description,
    action
}) {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '48px 24px',
            textAlign: 'center'
        }}>
            {icon && (
                <div style={{
                    fontSize: '48px',
                    marginBottom: '16px',
                    opacity: 0.5
                }}>
                    {icon}
                </div>
            )}
            <h3 style={{
                fontSize: '18px',
                fontWeight: '600',
                color: '#1e293b',
                marginBottom: '8px'
            }}>
                {title}
            </h3>
            {description && (
                <p style={{
                    fontSize: '14px',
                    color: '#64748b',
                    marginBottom: '24px',
                    maxWidth: '400px'
                }}>
                    {description}
                </p>
            )}
            {action}
        </div>
    );
}
